import React from "react";
import { CreditCard, Clock } from "lucide-react";

function ViewPayment() {
  return (
    <div className="w-full max-w-7xl mx-auto space-y-8 animate-in fade-in slide-in-from-bottom-5 duration-700">
      {/* Page Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-black text-gray-900 tracking-tight lowercase">
            System <span className="text-yellow-600">/</span> Payments
          </h1>
          <p className="text-gray-500 mt-1 font-medium tracking-tight">
            Financial auditing and M-Pesa transaction logs
          </p>
        </div>
        <div className="hidden sm:flex items-center gap-2 px-4 py-2 bg-yellow-50 border border-yellow-100 rounded-2xl">
          <div className="w-2 h-2 bg-yellow-500 rounded-full animate-pulse" />
          <span className="text-[10px] font-black text-yellow-700 uppercase tracking-widest">Awaiting Integration</span>
        </div>
      </div>

      {/* Futuristic Dashboard Placeholder */}
      <div className="bg-gradient-to-br from-gray-900 via-gray-950 to-black rounded-[2.5rem] p-10 md:p-16 shadow-[0_32px_64px_-12px_rgba(0,0,0,0.3)] relative overflow-hidden flex flex-col items-center justify-center text-center min-h-[500px] group">
        {/* Layered background flare effects */}
        <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-yellow-500/10 rounded-full blur-[120px] pointer-events-none -translate-x-1/2 -translate-y-1/2 group-hover:bg-yellow-500/20 transition-all duration-1000" />
        <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-yellow-600/5 rounded-full blur-[120px] pointer-events-none translate-x-1/2 translate-y-1/2" />
        <div className="absolute inset-0 border border-white/5 rounded-[2.5rem]" />

        <div className="relative z-10 max-w-2xl mx-auto space-y-10">
          <div className="relative">
            <div className="w-28 h-28 mx-auto bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-[2rem] flex items-center justify-center shadow-[0_0_50px_rgba(234,179,8,0.3)] transform group-hover:scale-110 group-hover:rotate-6 transition-all duration-700">
              <CreditCard className="w-12 h-12 text-white" />
            </div>
            <div className="absolute -bottom-2 -right-2 w-10 h-10 bg-gray-900 border-4 border-black rounded-full flex items-center justify-center">
              <Clock size={16} className="text-yellow-500 animate-spin-slow" />
            </div>
          </div>

          <div className="space-y-4">
            <h2 className="text-5xl font-black text-white leading-tight tracking-tighter">
              Financial <span className="text-yellow-500">Terminal</span>
            </h2>
            <p className="text-gray-400 text-lg font-medium leading-relaxed max-w-lg mx-auto">
              Our automated M-Pesa reconciliation engine is currently being synced with your business profile. Real-time auditing will be available shortly.
            </p>
          </div>

          {/* High Density Metric Placeholders */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 w-full">
            {[
              { label: "Daily Volume", value: "Locked" },
              { label: "Net Revenue", value: "Locked" },
              { label: "Audit Trait", value: "Active" },
              { label: "API Sync", value: "Wait" },
            ].map((stat) => (
              <div key={stat.label} className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-5 hover:bg-white/10 transition-all duration-300 group/stat">
                <p className="text-xs font-black text-yellow-500/50 uppercase tracking-widest group-hover/stat:text-yellow-500 transition-colors">{stat.label}</p>
                <div className="h-px w-8 bg-white/10 my-3 group-hover/stat:w-full transition-all duration-500" />
                <p className="text-lg font-black text-white lowercase tracking-tight">{stat.value}</p>
              </div>
            ))}
          </div>
          
          <div className="pt-6">
            <div className="h-1.5 w-48 bg-white/5 rounded-full mx-auto overflow-hidden">
              <div className="h-full bg-yellow-500 w-2/3 rounded-full animate-pulse" />
            </div>
            <p className="text-[10px] text-gray-500 font-bold uppercase tracking-[0.2em] mt-4">Module Preparation 67%</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewPayment;
